module.exports = __webpack_public_path__ + "bfb0938aad03ff4d533526ca59a09253.png";